import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDrag = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.857 2.25a1.607 1.607 0 1 0 0 3.214 1.607 1.607 0 0 0 0-3.214m6.143 0a1.607 1.607 0 1 0 0 3.214 1.607 1.607 0 0 0 0-3.214M8.857 9.964a1.607 1.607 0 1 0 0 3.215 1.607 1.607 0 0 0 0-3.215m6.143 0a1.607 1.607 0 1 0 0 3.214 1.607 1.607 0 0 0 0-3.214M8.857 17.68a1.607 1.607 0 1 0 0 3.214 1.607 1.607 0 0 0 0-3.214m6.143 0a1.607 1.607 0 1 0 0 3.214 1.607 1.607 0 0 0 0-3.214"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgDrag;
